module.exports = __webpack_public_path__ + "static/media/tickNew.7f935757.svg";